import { Sparkles, Users, Lightbulb, Book } from "lucide-react";
import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};

export const MissionSection = () => {
  const values = [
    {
      icon: <Book className="w-5 h-5" />,
      title: "Foundational",
      description: "Learn the fundamentals of Python programming."
    },
    {
      icon: <Users className="w-5 h-5" />,
      title: "Scalable",
      description: "Limitless possibilities for what you can build with Python."
    },
    {
      icon: <Lightbulb className="w-5 h-5" />,
      title: "Career-Focused",
      description: "Build skills that carry into future coding and STEM opportunities."
    }
  ];

  return (
    <section className="relative py-24 overflow-hidden">
      <div aria-hidden className="absolute top-0 left-0 right-0 h-px bg-border/90" />
      <div className="container mx-auto px-4 relative z-10">
        <motion.div 
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="max-w-5xl mx-auto text-center space-y-16"
        >
          {/* Header */}
          <motion.div variants={item} className="space-y-6">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-foreground">
              <span className="text-primary">Python</span> <span className="text-secondary">Coding Education</span>
            </h2>
            <motion.div 
              variants={item}
              className="h-0.5 bg-gradient-to-r from-primary/30 to-transparent w-24 mx-auto"
            />
            <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Learn Python with us and prepare for the new AI age.
            </p>
          </motion.div>

          {/* Values */}
          <div className="grid md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <motion.div 
                key={value.title}
                variants={item}
                className="group bg-white/90 backdrop-blur-sm rounded-xl p-8 border border-border shadow-card hover:shadow-hero transition-all"
              >
                <div className="space-y-6">
                  <div className="flex items-center justify-center">
                    <div className="flex items-center justify-center bg-secondary/30 h-14 w-14 rounded-full text-foreground">
                      {value.icon}
                    </div>
                  </div>

                  <h3 className="text-xl font-medium text-foreground">
                    {value.title}
                  </h3>

                  <p className="text-muted-foreground leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};